<template>
  <div>
    <div class="ui-pannel">
      <div class="title">
        <p class="txt">{{ $t('user.myTimetable') }}</p>
        <router-link to="/arrange" class="btn-arrange" v-if="user.state !== 0"
          >Set available times<!-- 我要排课 --></router-link
        >
      </div>
      <div class="content">
        <!-- {{ info.officialSkype }} -->
        <!-- <a target="_blank" :href="`callto://${info.officialSkype}`" class="btn-enter"
          >Start Lesson</a
        > -->
        <div class="course" v-if="recentCouse.length">
          <span class="name"
            >{{ $t('common.course') }}{{ $t('colon')
            }}{{ recentCouse[0].courseName }}</span
          >
          <span class="student">Student：{{ recentCouse[0].userName }}</span>
          <span class="time">{{ getTime1(recentCouse[0]) }}</span>
          <!-- <a @click="goToRoom(recentCouse[0])" class="btn-enter"
            >Start Lesson</a
          > -->
          <a
            target="_blank"
            :href="`callto://${info.officialSkype}`"
            class="btn-enter"
            >Start Lesson</a
          >
        </div>
        <div class="topic-box">
          <a class="pre" @click="changeDate(1)">{{ $t('weeks.pre') }}</a>
          <p class="topic">{{ $t('weeks.title') }}</p>
          <a class="next" @click="changeDate(2)">{{ $t('weeks.next') }}</a>
        </div>
        <ul class="dates">
          <li v-for="item in dateArr" :key="item.week">
            <span v-if="item.show === $t('weeks.today')">
              <p class="week">{{ item.show }}</p>
              <p class="date">{{ item.date }}</p>
            </span>
            <span v-else>
              <p class="week">{{ item.week }}</p>
              <p class="date">{{ item.show }}</p>
            </span>
          </li>
        </ul>
        <ul class="times" ref="times">
          <li v-for="(item, i) in bookArr" :key="i">
            <template v-if="item.length">
              <div
                :class="{
                  finished: cell.state === 2,
                  success: cell.state === 1 || cell.state === 5,
                  change: cell.state === 3,
                }"
                class="courseinfo"
                v-for="(cell, j) in item"
                :key="j"
                :style="getTop(cell.beginTime)"
              >
                <a
                  class="btn-delete"
                  @click="showDelete(i, j)"
                  v-if="![2, 9].includes(cell.state)"
                ></a>
                <p class="time">{{ getTime(cell) }}</p>
                <p class="info">{{ cell.userName }}</p>
                <!-- 课件 -->
                <a
                  class="btn"
                  @click="showCourseInfo(i, j)"
                  v-if="cell.state !== 3"
                  >Docs</a
                >
                <a
                  class="btn btn2"
                  @click="comfirmChange(cell)"
                  v-if="cell.state === 3"
                  >Reschedule Approval</a
                >
              </div>
            </template>
          </li>
          <!-- <li>
            <div class="success courseinfo" style="top: 322px">
              <a class="btn-delete" @click="comfirmInfo.show = true"></a>
              <p class="time">09:00-10:00</p>
              <p class="info">王同学</p>
              <a class="btn" @click="courseInfo.show = true">课件备课</a>
            </div>
            <div class="waiting courseinfo" style="top: 400px">
              <a class="btn-delete" @click="comfirmInfo.show = true"></a>
              <p class="time">09:00-10:00</p>
              <p class="info">王同学</p>
              <span class="btn btn2">待确定</span>
            </div>
            <div class="change courseinfo" style="top: 300px">
              <a class="btn-delete" @click="comfirmInfo.show = true"></a>
              <p class="time">09:00-10:00</p>
              <p class="info">王同学</p>
              <a class="btn btn2" @click="comfirmChange">改签审核</a>
            </div>
          </li>-->
        </ul>
      </div>
    </div>
    <update
      v-if="courseInfo.show"
      :course="bookArr[idx.x][idx.y]"
      :info="courseInfo"
    />
    <check :info="changeInfo" @refuse="refused" @comfirm="comfirm" />
    <comfirm
      @submit="comfirmNext"
      @cancel="comfirmInfo.show = false"
      :info="comfirmInfo"
    />
  </div>
</template>
<script>
import {
  getMyTeachingCourseList,
  getTeacherAppointedTimeList,
  getChangeApply,
  checkChange,
  getBaseProfile
} from '@/service/teacherApi.js'
import {
  delOrderCourse,
  getRecentOrderCourse,
  getRoomId,

} from '@/service/api.js'
import update from '@/components/UpdateCourse.vue'
import check from '@/components/Check.vue'
import comfirm from '@/components/Comfirm.vue'
import moment from 'moment'
import { roomUrl } from '@/service/env'
export default {
  components: { update, check, comfirm },
  data() {
    return {
      changeInfo: {
        show: false,
        before: '2019.10.21  09：00~ 10：00',
        after: '2019.10.21  11：00~ 12：00',
        course: 1,
        type: 1,
        cancel: 'Disagree',
        comfirm: 'Agree',
      },
      idx: { x: 0, y: 0 },
      dateArr: [
        { date: '', show: '', week: this.$t('weeks.mon') },
        { date: '', show: '', week: this.$t('weeks.tues') },
        { date: '', show: '', week: this.$t('weeks.wed') },
        { date: '', show: '', week: this.$t('weeks.thur') },
        { date: '', show: '', week: this.$t('weeks.fri') },
        { date: '', show: '', week: this.$t('weeks.sat') },
        { date: '', show: '', week: this.$t('weeks.sun') },
      ],
      currentDay: '',
      courseInfo: {
        show: false,
      },
      bookArr: [[]],
      comfirmInfo: {
        show: false,
        title: this.$t('common.tip'),
        topic: this.$t('common.comfirmSingerCourse'),
        desc: this.$t('common.comfirmInfoDesc'),
        cancel: this.$t('cancel'),
        comfirm: this.$t('common.submit'),
      },
      recentCouse: [],
      info: {}
    }
  },
  methods: {
    async getBaseProfile() {
      try {
        console.log(this.user.uid);
        let res = await getBaseProfile({ teacherId: this.user.uid })
        if (res.data.status === 1) {
          console.log(res.data.data);
          this.info = res.data.data
          // this.info.identityProof = this.info.identityProof.split('$_$')
        } else {
          this.$message.error(res.data.descript)
        }
      } catch (error) {
        this.$message.error(this.$t('common.Systemerror') + error.message)
      }
    },
    async comfirmChange(row) {
      // console.log(row)
      const res = await getChangeApply({ orderCourseId: row.id })
      if (res.data.status === 1) {
        this.changeInfo.before =
          moment(res.data.data.beginTime * 1000).format('YYYY-MM-DD HH:mm ~ ') +
          moment(res.data.data.endTime * 1000).format('HH:mm')
        this.changeInfo.after =
          moment(res.data.data.applyBeginTime * 1000).format(
            'YYYY-MM-DD HH:mm ~ '
          ) + moment(res.data.data.applyEndTime * 1000).format('HH:mm')
        this.changeInfo.show = true
        this.changeInfo.id = res.data.data.applyId
      }
    },
    async refused() {
      const res = await checkChange({
        applyId: this.changeInfo.id,
        applyState: 2,
        rejectReason: '...',
      })
      if (res.data.status === 1) {
        this.changeInfo.show = false
        this.getMyTeachingCourseList()
      }
    },
    async comfirm() {
      const res = await checkChange({
        applyId: this.changeInfo.id,
        applyState: 1,
      })
      if (res.data.status === 1) {
        this.changeInfo.show = false
        this.getMyTeachingCourseList()
      }
    },
    async comfirmNext() {
      console.log(this.bookArr[this.idx.x][this.idx.y]);
      const res = await delOrderCourse({
        orderCourseId: this.bookArr[this.idx.x][this.idx.y].id,
      })
      if (res.data.status === 1) {
        this.$message({ type: 'success', message: this.$t('common.cancelSuccess') })
        this.comfirmInfo.show = false
        this.bookArr[this.idx.x].splice(this.idx.y, 1)
      }
    },
    showDelete(i, j) {
      this.idx = { x: i, y: j }
      this.comfirmInfo.show = true
    },
    changeDate(type) {
      if (type === 1) {
        this.currentDay = moment(this.currentDay)
          .subtract(7, 'day')
          .format('YYYYMMDD')
      } else {
        this.currentDay = moment(this.currentDay)
          .add(7, 'day')
          .format('YYYYMMDD')
      }
      this.resetDate()
      this.getMyTeachingCourseList()
      this.$forceUpdate()
    },
    getTime1(item) {
      return (
        moment(item.beginTime * 1000).format('DD/MM/YYYY HH:mm - ') +
        moment(item.endTime * 1000).format('HH:mm')
      )
    },
    getTime(item) {
      return (
        moment(item.beginTime * 1000).format('HH:mm - ') +
        moment(item.endTime * 1000).format('HH:mm')
      )
    },
    getTop(time) {
      const h = moment(time * 1000).format('H')
      return { top: h * 145 + 'px' }
    },
    async getMyTeachingCourseList() {
      const res = await getMyTeachingCourseList({
        teacherId: this.user.uid,
        pageNO: 1,
        pageSize: 999,
        beginTime: this.dateArr[0].date.indexOf('\/') > 0 ? moment(this.dateArr[0].date, 'DD/MM').format('X') : moment(this.dateArr[0].date).format('X'),
        endTime: this.dateArr[6].date.indexOf('\/') > 0 ? moment(this.dateArr[6].date, 'DD/MM').format('X') : moment(this.dateArr[6].date).endOf('date').format('X'),
      })
      if (res.data.status === 1) {
        this.showCourseList(res.data.data)
      }
    },
    async getRecentCourse() {
      // const res = await getRecentOrderCourse({ teacherId: this.user.uid })
      // if (res.data.status === 1) {
      //   this.recentCouse = res.data.data
      // }
      const res = await getMyTeachingCourseList({
        state: 6,
        pageNO: 1,
        pageSize: 1,
      })
      if (res.data.status === 1) {
        this.recentCouse = res.data.data
      }
      if (this.recentCouse.length === 0) {
        const res = await getMyTeachingCourseList({
          state: 51,
          pageNO: 1,
          pageSize: 1,
        })
        if (res.data.status === 1) {
          this.recentCouse = res.data.data
        }
      }
    },
    resetDate() {
      let day = moment(this.currentDay).format('d')
      if (day == 0) {
        day = 7
      }
      for (let i = 0; i < 7; i++) {
        this.dateArr[i].date = moment(this.currentDay)
          .subtract(day - i - 1, 'day')
          .format('YYYY-MM-DD')
        if (
          moment(this.dateArr[i].date).format('YYYYMMDD') ===
          moment().format('YYYYMMDD')
        ) {
          this.dateArr[i].show = this.$t('weeks.today')
          this.dateArr[i].date = moment(this.dateArr[i].date).format('DD/MM')
        } else {
          this.dateArr[i].show = moment(this.dateArr[i].date).format('DD/MM')
        }
      }
    },
    showCourseList(data) {
      this.bookArr = [[], [], [], [], [], [], []]

      for (let i = 0; i < data.length; i++) {
        // console.log(
        //   data.map((item) => moment(item.beginTime * 1000).format('YYYYMMDD'))
        // )

        // console.log(
        //   moment(data[i].beginTime * 1000).format('YYYY-MM-DD HH:mm:ss')
        // )
        for (let j = 0; j < 7; j++) {
          // console.log('前'+moment(data[i].beginTime * 1000).format('YYYYMMDD'));
          if (
            moment(data[i].beginTime * 1000).format('YYYYMMDD') ==
            moment(this.dateArr[j].date, 'YYYY-MM-DD').format('YYYYMMDD')
          ) {
            this.bookArr[j].push(data[i])
          } else if (
            moment(this.dateArr[j].date, 'MM-DD').format('YYYYMMDD') ==
            moment(data[i].beginTime * 1000).format('YYYYMMDD')
          ) {
            this.bookArr[j].push(data[i])
          }
        }
      }
      // console.log(this.bookArr)
    },
    showCourseInfo(i, j) {
      this.idx = { x: i, y: j }
      this.courseInfo.show = true
      // console.log(this.bookArr[i][j])
    },
    goToRoom(course) {
      // let locale = this.$i18n.locale
      // switch (locale) {
      //   case 'cn':
      //     locale = 'zh-CN'
      //     break
      //   case 'TW':
      //     locale = 'zh-HK'
      //     break
      // }
      // const { teacherId, id, courseName, beginTime, endTime } = course
      // console.log('' + 17689263480 + '?call');
      // window.open(
      //   `skype:17689263480?call`
      // )
      // window.open(
      //   `${roomUrl}/?token=${sessionStorage.getItem('1to1token')}&locale=${locale}&teacher_id=${teacherId}&order_course_id=${id}&course_name=${courseName}&begin_time=${beginTime}&end_time=${endTime}#/init`
      // )
      // window.open(
      //   `./room/?locale=${locale}&teacher_id=${teacherId}&order_course_id=${id}&course_name=${courseName}&begin_time=${beginTime}&end_time=${endTime}&#/init`
      // )
      // window.open(
      //   `http://localhost:3001/?account=1&teacher_id=${teacherId}&order_course_id=${courseId}&course_name=${courseName}#/init`
      // )
    },
    async getRoomId(id) {
      const res = await getRoomId({
        orderCourseId: id,
        teacherId: this.user.id,
      })
      if (res.data.status === 1) {
        sessionStorage.setItem('roomId', res.data.data.roomid)
      }
    },
    getChangeApply() { },
  },
  computed: {
    user() {
      return JSON.parse(this.$store.getters.GETUSER)
    },
  },
  created() {
    this.$nextTick(() => {
      this.$refs.times.scrollTop = 1120
    })

    this.getRecentCourse()
    this.currentDay = moment().format('YYYYMMDD')
    this.resetDate()
    this.getMyTeachingCourseList()
    this.getBaseProfile()
  },
}
</script>
<style lang="scss" scoped>
.title {
  display: flex;
  .txt {
    flex: 1;
  }
  .btn-arrange {
    font-weight: normal;
    font-size: 14px;
    color: #fff;
    display: inline-block;
    padding: 0 22px;
    height: 40px;
    line-height: 40px;
    background: #a9c4b1;
    border-radius: 5px;
  }
}
.content {
  padding: 40px 50px;
}
.course {
  height: 50px;
  background: rgba(0, 33, 71, 0.1);
  font-size: 16px;
  color: #333;
  display: flex;
  padding: 0 40px;
  align-items: center;
  .name,
  .student {
    padding-right: 50px;
  }
  .time {
    flex: 1;
  }
  .btn-enter {
    display: inline-block;
    padding: 0 12px;
    height: 30px;
    border-radius: 5px;
    background: #002147;
    line-height: 30px;
    color: #fff;
    font-size: 14px;
  }
}
.topic-box {
  height: 100px;
  border-bottom: 1px solid #d6d6d6;
  display: flex;
  align-items: center;
  .topic {
    font-size: 18px;
    line-height: 42px;
    text-align: center;
    flex: 1;
    font-weight: bold;
  }
}
.pre,
.next {
  height: 42px;
  font-size: 16px;
  color: #666;
  line-height: 42px;
}
.pre {
  float: left;
  padding-left: 49px;
  background: url(../assets/arrow_left.png) no-repeat left center;
}
.next {
  float: right;
  padding-right: 49px;
  background: url(../assets/arrow_right.png) no-repeat right center;
}
.dates {
  overflow: hidden;
  height: 95px;
  border-bottom: 1px solid #d6d6d6;
  padding: 16px 37px 0;
  li {
    float: left;
    margin: 0 4px;
    width: 100px;
    text-align: center;
    font-size: 16px;
  }
  .date {
    color: #666;
    margin-top: 5px;
  }
}
.times {
  overflow-x: hidden;
  // overflow-y: auto;
  border-bottom: 1px solid #d6d6d6;
  margin: 0 37px;
  height: 540px;
  display: flex;
  li {
    flex: 1;
    margin: 0 3px;
    // padding: 20px 0;
    float: left;
    text-align: center;
    color: #666;
    line-height: 30px;
    position: relative;
    // height:2880px;
    min-height: 3470px;
  }
  li:nth-child(2n + 1) {
    background: #ebebeb;
  }
  li:nth-child(2n) {
    background: #8a8a8a;
  }
}
.courseinfo {
  // padding: 15px 3px;
  position: absolute;
  left: 0;

  font-size: 12px;
  color: #fff;
  background: #777;
  width: 100px;
  text-align: center;
  // padding: 32px 0 0;
  line-height: 16px;
  padding-top: 12px;
  height: 135px;
  &.finished {
    // min-height: 102px;
  }
  &.success {
    // padding-top: 12px;
    // height: 135px;
    background: #002147;
  }
  &.waiting {
    background: #a9c4b1;
  }
  &.change {
    background: #2680eb;
  }
  p {
    margin: 5px 0;
    line-height: 16px;
  }
  a.btn,
  a.btn2 {
    transition: background 0.3s;
  }
  .btn {
    display: inline-block;
    width: 100%;
    // height: 30px;
    text-align: center;
    padding: 5px 20px;
    margin: 8px 0 12px;
    line-height: 20px;
    border-radius: 30px;
    color: #fff;
    background: rgba($color: #fff, $alpha: 0.1);
  }
  a.btn:hover {
    background: rgba($color: #fff, $alpha: 0.5);
  }
  .btn2 {
    background: rgba($color: #000000, $alpha: 0.1);
  }
  a.btn2:hover {
    background: rgba($color: #000000, $alpha: 0.5);
  }
  .btn-delete {
    position: absolute;
    right: 0px;
    top: 0px;
    width: 18px;
    height: 18px;
    background: url(../assets/close.png) no-repeat center center;
    &:hover {
      opacity: 0.7;
    }
  }
}
</style>